import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b5985c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown"]
const _hoisted_2 = { class: "dialog_header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "button_wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "footer"
}

import SimpleButton from '@/components/atoms/SimpleButton'
import IconButton from '@/components/molecules/IconButton'
import i18n from '@/plugins/i18n'
import {
  ref,
  withDefaults,
  onBeforeUnmount,
  computed,
  watch,
  nextTick,
} from 'vue'

interface HTMLEvent<T extends EventTarget> extends Event {
  target: T
}
type PropsType = {
  modelValue?: boolean
  useCancelBtn?: boolean
  okBtnLabel?: string
  cancelBtnLabel?: string
  params?: { [key: string]: any } | null
  okBtnDisabled?: boolean
  loading?: boolean
  useFooter?: boolean
  widthSet?: boolean
  useConfirmClose?: boolean
  width?: number
  useFullSize?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogBase',
  props: {
    modelValue: { type: Boolean, default: false },
    useCancelBtn: { type: Boolean, default: false },
    okBtnLabel: { default: 'OK' },
    cancelBtnLabel: { default: i18n.global.t('dialog_base.cancel') },
    params: { default: null },
    okBtnDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    useFooter: { type: Boolean, default: true },
    widthSet: { type: Boolean, default: true },
    useConfirmClose: { type: Boolean, default: false },
    width: null,
    useFullSize: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "beforeClose", "close", "approve"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'beforeClose'): void
  (e: 'close'): void
  (e: 'approve', params: { [key: string]: any } | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, useCancelBtn: boolean, okBtnLabel: string, cancelBtnLabel: string, params: { [key: string]: any } | null, okBtnDisabled: boolean, loading: boolean, useFooter: boolean, widthSet: boolean, useConfirmClose: boolean, width?: number, useFullSize: boolean };





const toggleDialog = ref<boolean>(false)
const fullSize = ref<boolean>(false)
const dialogDiv = ref(null)

onBeforeUnmount(() => {
  if (displayFlag.value) {
    reset()
  }
})

const displayFlag = computed({
  get: () => props.modelValue,
  set: (newVal: boolean) => {
    emit('update:modelValue', newVal)
  },
})

const dialogBodyStyle = computed(() => {
  // -200はモーダルのヘッダー、フッターを余白分
  return {
    maxHeight: `${window.innerHeight - 200}px`,
  }
})

const dialogStyle = computed(() => {
  // -200はモーダルのヘッダー、フッターを余白分
  return {
    width: props.width + 'px',
  }
})

const fullSizeIcon = computed<string>(() => (fullSize.value ? 'fullscreen_exit' : 'fullscreen'))

const close = () => {
  // ローディング中はモーダルを閉じさせない
  if (props.loading) {
    return false
  }
  if (props.useConfirmClose && displayFlag.value) {
    emit('beforeClose')
  } else {
    displayFlag.value = false
    emit('close')
  }
}

const approve = () => {
  emit('approve', props.params)
}

const beforeAnimation = () => {
  toggleDialog.value = displayFlag.value
}

const keyDownEsc = (e: KeyboardEvent) => {
  // 日本語入力中ではなくescが押されたらダイアログを閉じる
  if (e.key === 'Escape' && !e.isComposing) {
    close()
  }
}

// tabを押してダイアログの外に出さなくするため
const tabFocus = (event: HTMLEvent<HTMLElement>) => {
  if (event.target) {
    event.target.parentNode?.focus()
  }
}

// shift + tabを押してダイアログの外に出さなくするため
const shiftTabFocus = (event: HTMLEvent<HTMLElement>) => {
  if (props.useCancelBtn && props.okBtnDisabled) {
    event.target.lastChild?.lastChild?.previousSibling?.firstChild?.focus()
  } else {
    event.target.lastChild?.lastChild?.previousSibling?.lastChild?.focus()
  }
}

const reset = () => {
  document.body.style.overflow = 'auto'
  document.body.removeEventListener('keydown', keyDownEsc)
}

const toggleFullSize = () => {
  fullSize.value = !fullSize.value
}

watch(toggleDialog, (v) => {
  if (v === true) {
    document.body.style.overflow = 'hidden'
    document.body.addEventListener('keydown', keyDownEsc)
    nextTick(() => {
      // 初期focus設定
      if (dialogDiv.value) {
        dialogDiv.value.focus()
      }
    })
  } else {
    reset()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    onEnter: beforeAnimation,
    onLeave: beforeAnimation
  }, {
    default: _withCtx(() => [
      (_unref(displayFlag))
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            onMousedown: _withModifiers(close, ["stop"]),
            class: "dialog_wrap",
            onMouseenter: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", {
              onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              tabindex: "0",
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (shiftTabFocus($event)))
            }, [
              _createVNode(_Transition, { name: "move" }, {
                default: _withCtx(() => [
                  (toggleDialog.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ dialogWidth: __props.widthSet, fullSize: fullSize.value }, "dialog"]),
                        style: _normalizeStyle(_unref(dialogStyle)),
                        tabindex: "0",
                        ref_key: "dialogDiv",
                        ref: dialogDiv
                      }, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "title")
                          ]),
                          _createElementVNode("span", _hoisted_4, [
                            (__props.useFullSize)
                              ? (_openBlock(), _createBlock(_unref(IconButton), {
                                  key: 0,
                                  "use-border": false,
                                  icon: _unref(fullSizeIcon),
                                  "icon-color": "color-dark2",
                                  disabled: __props.loading,
                                  onClick: toggleFullSize
                                }, null, 8, ["icon", "disabled"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IconButton), {
                              "use-border": false,
                              icon: "close",
                              "icon-color": "color-dark2",
                              disabled: __props.loading,
                              onClick: close
                            }, null, 8, ["disabled"])
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "dialog_body",
                          style: _normalizeStyle(_unref(dialogBodyStyle))
                        }, [
                          _renderSlot(_ctx.$slots, "body")
                        ], 4),
                        (__props.useFooter)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (__props.useCancelBtn)
                                ? (_openBlock(), _createBlock(_unref(SimpleButton), {
                                    key: 0,
                                    onClick: close,
                                    color: "color-primary",
                                    size: "size-m",
                                    disabled: __props.loading,
                                    "data-test": "dialog-btn-close"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(__props.cancelBtnLabel), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(SimpleButton), {
                                onClick: approve,
                                useBorder: false,
                                color: "bg-color-primary-grd",
                                size: "size-m",
                                disabled: __props.okBtnDisabled,
                                loading: __props.loading,
                                iconColor: "color-white",
                                "data-test": "dialog-btn-approve"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.okBtnLabel), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          tabindex: "0",
                          onFocus: _cache[0] || (_cache[0] = ($event: any) => (tabFocus($event)))
                        }, null, 32)
                      ], 6))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ], 32)
          ], 40, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})